import { AuthButton } from '@/web-app/views/users/components/auth-button'
import { CsrfInput } from '@/web-app/views/users/components/csrf-input'
import { addTimezoneAndAnalyticsTo } from '@/web-app/views/users/utils/add-timezone-and-analytics'
import googleLogo from '@/assets/google.png'

interface GoogleAuthButtonProps {
  authUrl?: string
  label: string
  fromGoogle?: boolean
  showCalendarNotFoundError?: boolean
  showMissingScopesError?: boolean
  showOopsError?: boolean
  showUnavailableCalendarError?: boolean
  showWorkEmailRequiredError?: boolean
}

export function GoogleAuthButton({
  authUrl,
  label,
  fromGoogle = false,
  showCalendarNotFoundError = false,
  showMissingScopesError = false,
  showOopsError = false,
  showUnavailableCalendarError = false,
  showWorkEmailRequiredError = false,
}: GoogleAuthButtonProps) {
  if (!authUrl) return null

  return (
    <form id='google_form' method='post' action={addTimezoneAndAnalyticsTo(authUrl)}>
      <CsrfInput />
      <AuthButton
        image={googleLogo}
        label={label}
        available
        missingScopes={fromGoogle && showMissingScopesError}
        oopsError={fromGoogle && showOopsError}
        unavailableCalendar={fromGoogle && showUnavailableCalendarError}
        workEmailRequired={fromGoogle && showWorkEmailRequiredError}
        calendarNotFound={fromGoogle && showCalendarNotFoundError}
      />
    </form>
  )
}
